import store from '@/src/store'
import { getToken } from '@service/http/auth'

const DEFAULT_ROUTE_CONFIG = () => {
  return {
    notify: {
      error: (error, notify) => {
        store.dispatch('notify/error', notify)
      },
    },
    profile: {
      getToken,
      gotoLogin: () => store.dispatch('gotoLogin'),
      logOut: () => store.dispatch('auth/logOut'),
      getInfo: () => store.dispatch('auth/getInfo'),
      check: (permissions) =>
        new Promise((resolve, reject) => {
          if (!permissions || permissions.length < 1) {
            resolve(true)
            return
          }
          resolve(store.getters['auth/currentUser'].hasPermissions(permissions))
        }),
    },
    convertPermission(acc, cur) {
      if (!acc) {
        acc = {
          requiresNoAuth: false,
          requiresAuth: false,
          permissions: [],
        }
      }
      const meta = cur.meta || {}
      if (meta.requiresAuth) acc.requiresAuth = true
      if (meta.requiresNoAuth) acc.requiresNoAuth = true

      if (meta.scopes) {
        const diff = meta.scopes.filter(
          (x) => !acc.permissions.find((i) => i == x)
        )
        acc.permissions.push(...diff)
      }
      return acc
    },
    loading: {
      setLevel() {
        return store.commit('loading/setLoading', true)
      },
      reset() {
        return store.commit('loading/setLoading', false)
      },
      setLoadingBar(value) {
        return store.commit('loading/setLoadingBar', value)
      },
    },
    redirect: {
      home: {
        name: 'home',
        replace: true,
      },
      login: (to) => ({
        name: 'login',
        query: {
          redirect: to.path,
        },
        replace: true,
      }),
    },
  }
}
export { DEFAULT_ROUTE_CONFIG }
